import { forwardRef } from "react";
import type { UserAvatarProps } from "@/components/Layout";
import { generateFallbackAvatarUrl } from "@/components/Layout";

export const UserAvatar = forwardRef<HTMLDivElement, UserAvatarProps>(
  ({ user }, ref) => {
    if (!user) return null;

    if (user.photoURL) {
      return (
        <div ref={ref} className="relative inline-block">
          <img
            className="h-10 w-10 rounded-full object-cover ring-2 ring-primary-100"
            src={user.photoURL}
            alt={user.displayName || "Usuário"}
            onError={(e) => {
              const fallbackName = user.displayName || "U";
              e.currentTarget.src = generateFallbackAvatarUrl(fallbackName);
            }}
          />
        </div>
      );
    }

    return (
      <div ref={ref} className="relative inline-block">
        <div
          className="h-10 w-10 rounded-full bg-primary-500 flex items-center justify-center text-white font-montserrat font-semibold ring-2 ring-primary-100"
        >
          {(user.displayName?.[0] || user.email?.[0] || "U").toUpperCase()}
        </div>
      </div>
    );
  }
);

export default UserAvatar;
